var map = {
	"./about.vue": [
		1863,
		863
	],
	"./index.vue": [
		3526,
		526
	],
	"./test/begin.vue": [
		6010,
		120,
		10
	],
	"./test/end.vue": [
		6454,
		454
	],
	"./test/fail.vue": [
		7898,
		898
	],
	"./test/tripleDial.vue": [
		4683
	],
	"./trial/audioTrial.vue": [
		3219,
		219
	],
	"./trial/mathTrial.vue": [
		9990,
		990
	],
	"./trial/shapeTrial.vue": [
		2151,
		780
	],
	"./user/login.vue": [
		2881,
		881
	],
	"./user/view.vue": [
		3314,
		314
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3457;
module.exports = webpackAsyncContext;